import { render, staticRenderFns } from "./transactionbank.vue?vue&type=template&id=93a6e830&"
import script from "./transactionbank.vue?vue&type=script&lang=js&"
export * from "./transactionbank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports